export default "__VITE_ASSET__Ja2$Ev_5__"